import React from 'react';

import Wrapper from './Layout/Wrapper';

const MaskImage = ({ image }) => {
    if (!image?.url) {
        return null;
    }

    return (
        <Wrapper>
            <figure className="mask-image">
                <img 
                    className="mask-image__image"
                    src={image.url}
                    alt={image.altText || ''}
                    srcSet={image.srcSet || ''}
                    width="350"
                    height="350"
                    loading="lazy"
                    sizes="500px"
                />
            </figure>
        </Wrapper>
    );
}

export default MaskImage;